import React from 'react';
import { FreeBetMaxPayoutPopUp, MaxWinPopup } from '@pascal/pascal-core';
import Game from './game';
import GameLatestResults from './gameLatestResults';
import GameResultPopUp from '../../gameResultPopUp';
import { CountDown } from '../../countDown';
import { YouWinPopUp } from '../../youWinPopUp';
import { toFixed } from '../../../../helpers/arithmeticOperations';
import { globalTranslationKeys } from '../../../../enums';

const GameMainTop = ({
  t,
  roundId,
  results,
  totalWin,
  winAmount,
  currentOdd,
  gameLoading,
  finishedOdd,
  currencyCode,
  isActiveVideo,
  repliedBetData,
  isShowGameResultPopup,
}) => {
  const type_2 = +toFixed(+currentOdd, 2) > 1 && +toFixed(+currentOdd, 2) <= 3;
  const type_3 = +toFixed(+currentOdd, 2) > 3 && +toFixed(+currentOdd, 2) <= 10;
  const type_4 = +toFixed(+currentOdd, 2) > 10;

  return (
    <div className='oddball-game-top'>
      <MaxWinPopup />
      <FreeBetMaxPayoutPopUp />
      <div className='oddball-game-content'>
        <div
          className='odd-game-round-id-cont'
          title={`${t(globalTranslationKeys.RoundId)} ${roundId}`}
        >
          <p className='odd-round-id-text'>
            {t(globalTranslationKeys.RoundId)}: <span>{roundId}</span>
          </p>
        </div>
        <div className='odb-popup-wrapper'>
          {finishedOdd && isShowGameResultPopup && (
            <GameResultPopUp t={t} finishedOdd={finishedOdd} />
          )}
          {winAmount || (finishedOdd && totalWin && !isShowGameResultPopup) ? (
            <YouWinPopUp t={t} currencyCode={currencyCode} amount={winAmount || totalWin} />
          ) : (
            <></>
          )}
        </div>
        {!repliedBetData ? (
          <div className='v-block-coef-row'>
            <GameLatestResults data={results} />
          </div>
        ) : (
          <></>
        )}

        {!gameLoading && <CountDown />}
        {!gameLoading && currentOdd && (
          <p className={`odd-game-coef type-${type_2 ? '2' : type_3 ? '3' : type_4 ? '4' : '1'}`}>
            {currentOdd ? 'x' : ''}
            {currentOdd ? `${(Math.trunc(currentOdd * 100) / 100).toFixed(2)}` : ''}
          </p>
        )}
        {/* add type-1,type-2,type-3,type-4,type-5 class */}
        <Game isActiveVideo={isActiveVideo} />
      </div>
    </div>
  );
};

export default GameMainTop;
